import { Row, Col, Card, Statistic, notification } from 'antd';
import pagination from 'antd/lib/pagination';
import { FC, useEffect, useState } from 'react';
import restful from '../../restful';

type Balance = {
    status: string;
    balance: string;
    currency: string;
}
const MelipayamakCredit: FC = () => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [credit, setCredit] = useState<string>("0");

    const fetchData = () => {
        setIsLoaded(true);
        restful.get(`/melipayamak/credit`)
            .then((res) => {
                setCredit(res.data.result.credit.Value);
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <Card>
            <Statistic title="اعتبار ملی پیامک" loading={isLoaded} value={parseInt(credit)} suffix="SMS"/>
        </Card>
    );
}

export default MelipayamakCredit;
